<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/khtOhZ/tc-custom/9781429904551.jpg?1737196545475" alt="This image is the cover for the book Born to Rule"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Born to Rule
      </h1>
      <p class="bookDescription body article font2">
        <p>Julia Gelardi's <i>Born to Rule</i> is an historical tour de force that weaves together the powerful and moving stories of the five royal granddaughters of Queen Victoria. These five women were all married to reigning European monarchs during the early part of the 20th century, and it was their reaction to the First World War that shaped the fate of a continent and the future of the modern world. <br/><br/>Here are the stories of Alexandra, whose enduring love story, controversial faith in Rasputin, and tragic end have become the stuff of legend; Marie, the flamboyant and eccentric queen who battled her way through a life of intrigues and was also the mother of two Balkan queens and of the scandalous Carol II of Romania; Victoria Eugenie, Spain's very English queen who, like Alexandra, introduced hemophilia into her husband's family-with devastating consequences for her marriage; Maud, King Edward VII's daughter, who was independent Norway's reluctant queen; and Sophie, Kaiser Wilhelm II's much maligned sister, daughter of an Emperor and herself the mother of no less than three kings and a queen, who ended her days in bitter exile.<br/><br/><i>Born to Rule</i> evokes a world of luxury, wealth, and power in a bygone era, while also recounting the ordeals suffered by a unique group of royal women who at times faced poverty, exile, and death.  Praised in their lifetimes for their legendary beauty, many of these women were also lauded-and reviled-for their political influence. Using never before published letters, memoirs, diplomatic documents, secondary sources, and interviews with descendents of the subjects, Julia Gelardi's <i>Born to Rule</i> is an astonishing and memorable work of popular history.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Julia P. Gelardi
      </h2>
      
      <p class="authorDescription body article"><B>Julia Gelardi</B> was born in Manila, Philippines, and educated in the United States and Canada. An independent historian and author, she lives with her husband and two daughters in Plymouth, Minnesota.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a990596e